module.exports = __webpack_public_path__ + "img/Limpieza-R.cec513d3.png";